var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTimeline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Time Circle"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Time Circle_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.6947 20.5C5.1747 20.5 0.694702 16.03 0.694702 10.5C0.694702 4.98 5.1747 0.5 10.6947 0.5C16.2247 0.5 20.6947 4.98 20.6947 10.5C20.6947 16.03 16.2247 20.5 10.6947 20.5ZM13.8847 14.21C14.0047 14.28 14.1347 14.32 14.2747 14.32C14.5247 14.32 14.7747 14.19 14.9147 13.95C15.1247 13.6 15.0147 13.14 14.6547 12.92L11.0947 10.8V6.18C11.0947 5.76 10.7547 5.43 10.3447 5.43C9.9347 5.43 9.5947 5.76 9.5947 6.18V11.23C9.5947 11.49 9.7347 11.73 9.9647 11.87L13.8847 14.21Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimeline);
export default __webpack_public_path__ + "static/media/timeline.9a50a8df217b9b2ed846d3d27d9df7a2.svg";
export { ForwardRef as ReactComponent };